"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var menuItemConfig_1 = require("../menuItemConfig");
exports.default = new menuItemConfig_1.BaseMenuItemConfiguration({
    consumable: true,
    filters: [
        {
            name: 'topping',
            type: 'Boolean',
        },
    ],
    hasDescription: true,
    hasHours: false,
    hasImage: true,
    hasVariations: true,
    hasPos: true,
    lists: [],
    name: 'Modifier',
    options: {
        allowOnSide: false,
        topping: false,
        min: 0,
        max: 1,
    },
    pluralizedName: 'Modifiers',
    sellable: true,
    sortKeys: [],
    unlinkedOptions: [],
    version: 11,
});
//# sourceMappingURL=modifier.js.map